"use client";

import Image from "next/image";
import awardImg1 from "@/assets/awards/img1.webp";
import awardImg2 from "@/assets/awards/img2.webp";
import awardImg3 from "@/assets/awards/img3.webp";
import awardImg4 from "@/assets/awards/img4.webp";
import awardImg5 from "@/assets/awards/img5.webp";
import Title from "../Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";

// import "swiper/css";
import "swiper/css/free-mode";
// import "./Awards.css";

const AwardsSlider = ({ data }) => {
  // Media URL helper
  const getMediaUrl = (media) => {
    const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL || "http://localhost:1337";
    const url = media?.url || media?.data?.attributes?.url || media?.data?.url;
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${baseUrl}${url}`;
  };

  const defaultAwards = [
    { img: awardImg1, alt: "Best University in India for Industry Interface 2025 by CEGR", text: "Best University in India for Industry Interface 2025 by CEGR" },
    { img: awardImg2, alt: "Best Skill University of the Year - 2023 Awarded by Brand Honchos", text: "Best Skill University of the Year - 2023 Awarded by Brand Honchos" },
    { img: awardImg3, alt: "Pioneer in Tech-Empowered Education for Social Impact Award by Digii Day", text: "Pioneer in Tech-Empowered Education for Social Impact Award by Digii Day" },
    { img: awardImg4, alt: "FE India Education Awards 2025: Emerging University of the Year", text: "FE India Education Awards 2025: Emerging University of the Year" },
  ];

  const awards = data && data.length > 0
    ? data.map(item => ({
      img: getMediaUrl(item.Award_image) || awardImg1,
      alt: item.Image_description || "Award",
      text: item.Image_description || ""
    }))
    : defaultAwards;

  return (
    <section className="relative w-full overflow-hidden">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <Swiper
          modules={[Autoplay, FreeMode]}
          loop={true}
          speed={12000}
          autoplay={{
            delay: 0,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          }}
          freeMode={true}
          grabCursor={true}
          breakpoints={{
            320: { slidesPerView: 1.2, spaceBetween: 15 },
            640: { slidesPerView: 2.2, spaceBetween: 15 },
            1024: { slidesPerView: 3, spaceBetween: 15 },
          }}
          className="awards-swiper"
        >
          {awards.map((award, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative overflow-hidden group transition-transform duration-700 h-[250px] md:h-[300px] lg:h-[350px] max-w-[450px] mx-auto"
              >
                <Image
                  src={award.img}
                  alt={award.alt}
                  fill
                  className="object-cover transition-transform duration-700 group-hover:scale-110"
                />

                <div
                  className="absolute inset-0 z-10 opacity-100 overflow-hidden
                  md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700"
                  style={{
                    background: "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)",
                  }}
                />

                <div
                  className="overflow-hidden absolute bottom-2 md:bottom-4 lg:bottom-6 left-5 right-2 z-20 text-white 
                  opacity-100 md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 lg:group-hover:opacity-100 transition-opacity duration-700"
                >
                  <p className="text-[13px] md:text-[14px] font-semibold opacity-90 w-full break-words leading-tight line-clamp-2 overflow-hidden">
                    {award.text}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default AwardsSlider;
